import React, { useState, useEffect } from "react";
import bsBreakpoints from "bs-breakpoints";
import classNames from "classnames";
import PageSection from "../PageSection/PageSection";
import ResponsivePageHeader from "../ResponsivePageHeader/ResponsivePageHeader";
import { Row, Col, Image } from "react-bootstrap";
const InfrastructureITLabResponsive = () => {
	const [currentBreakPoint, setCurrentBreakPoint] = useState("");

	useEffect(() => {
		bsBreakpoints.init();
		setCurrentBreakPoint(bsBreakpoints.getCurrentBreakpoint());

		const handleBreakPoint = (event) => {
			setCurrentBreakPoint(event.detail);
		};

		window.addEventListener("new.bs.breakpoint", handleBreakPoint);

		return () => {
			window.removeEventListener("new.bs.breakpoint", handleBreakPoint);
		};
	}, []);

	const descriptionClasses = classNames("mb-4 text-center text-text-color", {
		"font-sm": currentBreakPoint === "xSmall" || currentBreakPoint === "small",
	});

	return (
		<PageSection bgClass="light">
			<ResponsivePageHeader title="IT Lab" />

			{/* <PageSectionHeader title="Collegeinfrastructure" rightStyle="bottom" /> */}
			<Row className="justify-content-center">
				<Row className="justify-content-center mb-4">
					<Col md="4" className="mb-4">
						<Image
							src={require("../../assets/infrastructure/iicroom 2.jpg").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					{/* <Col md="4" className="mb-4">
						<Image
							src={
								require("../../assets/infrastructure/iic room 3.jpg").default
							}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col> */}
					<Col md="4" className="mb-4">
						<Image
							src={require("../../assets/infrastructure/iic2.JPG").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="4" className="mb-4">
						<Image
							src={require("../../assets/infrastructure/labs (1).JPG").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="4" className="mb-4">
						<Image
							src={require("../../assets/infrastructure/labs (2).JPG").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="4" className="mb-4">
						<Image
							src={require("../../assets/infrastructure/labs (3).JPG").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
					<Col md="4" className="mb-4">
						<Image
							src={require("../../assets/infrastructure/labs (5).JPG").default}
							className="img-fluid rounded mb-4 image-coverfit"
						/>
					</Col>
				</Row>
			</Row>
		</PageSection>
	);
};

export default InfrastructureITLabResponsive;
